interface CollapsibleHeaderProps {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
}

export const CollapsibleHeader = ({
  title,
  isOpen,
  onToggle,
}: CollapsibleHeaderProps) => {
  return (
    <button
      onClick={onToggle}
      className="flex items-center justify-between w-full lg:py-3 lg:pb-5 text-left lg:border-b border-gray-200 "
    >
      <span className="font-medium text-lg text-grey-dark">{title}</span>
      <svg
        className={`w-[37px] h-[37px] text-grey-dark transition-transform duration-200 pl-2 lg:pl-0 lg:pr-3 ${
          isOpen ? 'rotate-180' : ''
        }`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 20 26"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </button>
  );
};
